import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, FilasEsperaReducer, FilasEsperaState } from "./filas-espera-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IFilaEsperaPagedResponse } from "models/response/fila-espera-paged-response";

const FilasEsperaContext = createContext<FilasEsperaState | undefined>(undefined);
const FilasEsperaContextDispatchContext = createContext({} as any);

const FilasEsperaProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(FilasEsperaReducer, {
        filas: new PaginationResponse<IFilaEsperaPagedResponse>([], 0, 1, 10, 0),
        filaPagedRequest: { page: 0, pageSize: 10 },
        tipos: [],
        ultimaAtualizacao: null,
        loading: false,
        error: null
    } as FilasEsperaState);

    return (
        <FilasEsperaContext.Provider value={state}>
            <FilasEsperaContextDispatchContext.Provider value={dispatch}>
                {children}
            </FilasEsperaContextDispatchContext.Provider>
        </FilasEsperaContext.Provider>
    );
}

const useFilasEsperaState = () => {
    const context = useContext(FilasEsperaContext);
    if (context === undefined) {
        throw new Error('useFilasEsperaState must be used within a FilasEsperaProvider');
    }
    return context;
}

const useFilasEsperaDispatch = () => {
    const context = useContext(FilasEsperaContextDispatchContext);
    if (context === undefined) {
        throw new Error('useFilasEsperaDispatch must be used within a FilasEsperaProvider');
    }
    return context;
}

export { FilasEsperaProvider, useFilasEsperaState, useFilasEsperaDispatch, ACTION_TYPES };
